import { render, staticRenderFns } from "./TOProposalPolicyholder.vue?vue&type=template&id=1c560bfa"
import script from "./TOProposalPolicyholder.vue?vue&type=script&lang=js"
export * from "./TOProposalPolicyholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports